import { useState, useEffect } from 'react';
import PageHeader from '../components/molecules/PageHeader';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import dayjs from 'dayjs';

const Payments = () => {
  const [paidStudents, setPaidStudents] = useState([]);
  const syncPaymentWithStudents = () => {
    const syncData = new FormData();
    syncData.append('auth', localStorage.getItem('token'));
    syncData.append('mode', 'syncPayments');

    axios.post(config.STUDENTS_API, syncData).then(output => {
      console.log(output.data.response);
    });
  };

  useEffect(() => {
    const getPayment = new FormData();
    getPayment.append('auth', localStorage.getItem('token'));
    getPayment.append('mode', 'getPayments');

    axios.post(config.STUDENTS_API, getPayment).then(output => {
      if (output.data.response.status === 'OK') {
        setPaidStudents(output.data.response.payment);
      }
    });
  }, []);

  const RightHandSide = () => {
    return <Link onClick={syncPaymentWithStudents}>Sync Students Table</Link>;
  };
  return (
    <div>
      <PageHeader RightSideComponent={RightHandSide}>
        Payment Manager
      </PageHeader>

      <div className='my-4'>Paid Students: {paidStudents?.length}</div>
      <div className='grid grid-cols-3 gap-2'>
        <div className='bg-primary-100 p-2 text-xl font-medium'>Student</div>
        <div className='bg-primary-100 p-2 text-xl font-medium'>Amount</div>
        <div className='bg-primary-100 p-2 text-xl font-medium'>Date</div>

        {paidStudents?.map(student => {
          return (
            <>
              <div className='p-2'>
                <Link to={`/manage/students/${student.id}`}>
                  {student.name}
                </Link>
              </div>
              <div className='p-2'>{student.amount}</div>
              <div className='p-2'>
                {dayjs(student.date).format('DD MMMM YYYY')}
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default Payments;
